import React from 'react'
import FooterNavitem from './Component/FooterNavitem'
import './Footer.css'
import { FooterNavItems } from '../../Components/Navbar/Data/NavItemsList'

export default function Footer() {
    return (
        <footer className='section section-footer container-vertical res-gap-32'>

            <h4>WOLF INVESTMENT</h4>

            <div className='disclaimer container-vertical res-gap-8'>
                <h6 className='text-align-center clr-grey-400'>
                    DISCLAMER
                </h6>
                <p className='fs-regular text-align-center clr-grey-400'>
                    Stock Trading is inherently risky and the users agree to assue complete and full responsibility for the outcomes of all trading decisions that they make, including but not limited to loss of capital.
                    <br /><br />
                    Mutual Fund investments are subject to market risks, read all scheme related documents carefully.
                </p>
            </div>



            <div className='footer-navitems res-gap-8'>
                {FooterNavItems.map((element, index) => {
                    return <FooterNavitem key={index} route={element.route} itemName={element.item} />
                })}
            </div>

            <div className='copyright-mark clr-grey-600 fw-semibold fs-tiny'>
                © 2023 Sachin Anpat / All rights reserved / Privacy
            </div>

        </footer>
    )
}
